import {
	useAllergens,
	useBaseIngredientCategories,
	useBaseIngredientRanges,
	useBaseIngredientRangesArchived,
	useCo2Labels,
	useNutriScoreLabels,
	useSeasons,
	useTagList,
} from 'context/Store';

export default function useBaseIngredientSearchData() {
	const allergens = useAllergens();
	const baseIngredientCategories = useBaseIngredientCategories();
	const co2Labels = useCo2Labels();
	const nutriScoreLabels = useNutriScoreLabels();
	const ranges = useBaseIngredientRanges();
	const rangesArchived = useBaseIngredientRangesArchived();
	const seasons = useSeasons();
	const tags = useTagList();

	return {
		allergens,
		baseIngredientCategories,
		co2Labels,
		nutriScoreLabels,
		ranges,
		rangesArchived,
		seasons,
		tags,
	};
}
